<div class="_landing-page">

	<div class="_flex-grow">
		<div class="_container">

			<div class="_login">

				<div class="_header">
					<p class="_title" [innerHtml]="'LANDING_PAGE.TITLE' | translate"></p>
					<p class="_title" [innerHtml]="'LANDING_PAGE.SUBTITLE' | translate"></p>
					<p class="_description" >
						{{'LANDING_PAGE.DESCRIPTION_PT1' | translate}}
					</p>
				</div>			
	
				<div class="_buttons">
					<span class="_button" (click)="navigateToPublicPage()">
						<b>{{'LANDING_PAGE.FIND_HELP' | translate}}</b>
						<ion-icon src="./assets/icons/double-right-outline.svg"></ion-icon>
					</span>
				</div>	

				<div class="_logo">
					<img class="__logo" src="./assets/BEEGO_logo.png" />
				</div>
			</div>
		</div>
	</div>

	<div class="_login-button">
		<span class="_button" (click)="navigateToLogin()">
			{{'LANDING_PAGE.FOR_GOVERNMENTS' | translate}}
			<ion-icon src="./assets/icons/double-right-outline.svg"></ion-icon>
		</span><br>
	</div>

	<logo-slider-component></logo-slider-component>

</div>
